import axios from 'axios';
import { URLS } from "./URLS";

export const authenticateWithGoogle = async (data) => {
  return axios.post(URLS.GOOGLE_AUTH, data)
    .then(p => {
      axios.defaults.headers['Authorization'] = `Bearer ${p.data.user.accessToken}`;
      return p.data;
    });
}

export const updateZoomIntegration = async (data) => {
  return axios.post(URLS.ZOOM_INTEGRATION, data)
    .then(p => {
      return p.data;
    });
}
export const getVersion = async () => {
  return axios.get(URLS.GET_VERSION)
  .then(p => p.data);
}

